import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaGhost } from 'react-icons/fa';
import useStore from '../../../store';

const useThemeClass = () => {
  const theme = useStore(state => state.ref.menu.activeTheme) || 'cardcolor';
  return `mafia-generic-card theme-${theme}`;
};

// Добавляем definition в аргументы
export const RoleRevealScreen = ({ role, team, word, teammates, onClose, definition }) => {
  const { t } = useTranslation();
  const cardClass = useThemeClass();

  const isMafia = team === 'mafia';
  const isTown = team === 'town';

  let icon = '👀';
  let headerClass = 'team-neutral';
  let titleKey = 'mafia.spectator_title';
  let descKey = 'mafia.spectator_desc';

  if (isTown) { headerClass = 'team-civilian'; }
  else if (isMafia) { headerClass = 'team-mafia'; }

  if (role === 'doctor') {
    icon = '👨‍⚕️'; titleKey = 'mafia.role_card_doctor'; descKey = 'mafia.role_card_desc_doctor';
  } else if (role === 'detective') {
    icon = '🕵️‍♂️'; titleKey = 'mafia.role_card_detective'; descKey = 'mafia.role_card_desc_detective';
  } else if (isMafia) {
    icon = '🕴️'; titleKey = 'mafia.you_mafia'; descKey = 'mafia.desc_mafia';
  } else if (isTown) {
    icon = '😇'; titleKey = 'mafia.you_civilian'; descKey = 'mafia.desc_civilian';
  }

  // ДОБАВИТЬ: Логика форматирования определения
  const formatDefinition = (text) => {
    if (!text) return null;
    let clean = text.trim();

    // Обрезка по длине (100 символов)
    if (clean.length > 100) {
        clean = clean.slice(0, 100).trim() + '...';
    }

    // Обрезка по строкам (5 строк)
    const lines = clean.split('\n');
    if (lines.length > 5) {
        clean = lines.slice(0, 5).join('\n') + '...';
    }

    return clean;
  };

  const defText = formatDefinition(definition);

  return (
    <div className="mafia-overlay-bg">
      <div className={cardClass}>
        <div className={`mpc-header ${headerClass}`}>
          <div className="mpc-icon">{icon}</div>
          <div className="mpc-title">{t(titleKey)}</div>
        </div>
        <div className="mpc-content">
          <div className="mpc-desc">{t(descKey)}</div>

          {/* ИЗМЕНЕННЫЙ БЛОК ДЛЯ СЛОВА И ОПРЕДЕЛЕНИЯ */}
          {isTown && word && (
            <>
                <div className="mpc-target-word">{word}</div>
                {/* Показываем определение только если оно есть и валидно */}
                {defText && (
                    <div className="mpc-definition">
                        {defText}
                    </div>
                )}
            </>
          )}

          {isMafia && teammates?.length > 0 && (
            <div className="mpc-teammates">
              <span>{t('mafia.team_label')}</span><br />
              {teammates.map((name, i) => (
                <span key={i}>{name}{i < teammates.length - 1 ? ', ' : ''}</span>
              ))}
            </div>
          )}
        </div>
        <button className="mpc-button" onClick={onClose}>
          {t('mafia.lets_go', 'ПОГНАЛИ')}
        </button>
      </div>
    </div>
  );
};

export const GhostWelcomeScreen = ({ isSpectator, onEnter }) => {
  const { t } = useTranslation();
  const cardClass = useThemeClass();

  return (
    <div className="mafia-overlay-bg">
      <div className={cardClass}>
        <div className="mpc-header team-neutral" style={{ backgroundColor: '#777' }}>
          <div className="mpc-icon"><FaGhost /></div>
          <div className="mpc-title">{isSpectator ? t('mafia.spectator_ghost_chat_title') : t('mafia.ghost_title')}</div>
        </div>
        <div className="mpc-content">
          <p className="mpc-desc">
            {isSpectator ? t('mafia.spectator_allowed_desc') : t('mafia.ghost_desc')}
          </p>
        </div>
        <button className="mpc-button" onClick={onEnter}>
          {t('mafia.ghost_enter')}
        </button>
        <button className="mpc-button secondary" onClick={() => window.Telegram?.WebApp?.close()}>
          {t('mafia.ghost_leave')}
        </button>
      </div>
    </div>
  );
};

export const InterrogationScreen = ({ role, onDismiss }) => {
  const { t } = useTranslation();
  const cardClass = useThemeClass();

  const isDetective = role === 'detective';
  const isMafia = role === 'mafia';

  let title = t('mafia.interrogation_suspect_title');
  let desc = isMafia ? t('mafia.interrogation_suspect_mafia_desc') : t('mafia.interrogation_suspect_civilian_desc');
  let headerClass = isMafia ? 'team-mafia' : 'team-civilian';

  if (isDetective) {
    title = t('mafia.interrogation_detective_title');
    desc = t('mafia.interrogation_detective_desc');
    headerClass = 'team-civilian';
  }

  return (
    <div className="mafia-overlay-bg">
      <div className={cardClass}>
        <div className={`mpc-header ${headerClass}`}>
          <div className="mpc-icon">🔦</div>
          <div className="mpc-title">{title}</div>
        </div>
        <div className="mpc-content">
          <div className="mpc-desc">{desc}</div>
        </div>
        <button className="mpc-button" onClick={onDismiss}>
          {t('mafia.btn_understood', 'ПОНЯТНО')}
        </button>
      </div>
    </div>
  );
};